var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"componente",style:({width: _vm.width, height:_vm.heigth, position: _vm.position, top:_vm.top, left:_vm.left })})
}
var staticRenderFns = []

export { render, staticRenderFns }